import { createApi } from "@reduxjs/toolkit/query/react";

import { createInfiniteQuery } from "./infiniteQuery";

import { IActivity } from "@/interfaces/activity.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

export const activityApi = createApi({
  reducerPath: "activityApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["Activity"],
  endpoints: (builder) => ({
    getInfiniteActivities: createInfiniteQuery<IActivity[]>(
      builder,
      `workspace/${getWorkspace() || undefined}/activity`,
      ["Activity"],
      1,
    ),
  }),
});

export const { useGetInfiniteActivitiesInfiniteQuery } = activityApi;
